import React, { createContext, useContext, useState, useEffect } from 'react';
import EpisodeProgressNotification from '../components/EpisodeProgressNotification';

const EpisodeNotificationContext = createContext();

export const useEpisodeNotifications = () => {
  const context = useContext(EpisodeNotificationContext);
  if (!context) {
    throw new Error('useEpisodeNotifications must be used within an EpisodeNotificationProvider');
  }
  return context;
};

export const EpisodeNotificationProvider = ({ children }) => {
  const [activeNotifications, setActiveNotifications] = useState([]);

  const addEpisodeNotification = (episodeId) => {
    console.log('🔔 EpisodeNotificationContext: addEpisodeNotification called with ID:', episodeId);

    // Check if notification already exists
    if (activeNotifications.find(n => n.id === episodeId)) {
      console.log('⚠️ Notification already exists for episode:', episodeId);
      return;
    }

    const notification = {
      id: episodeId,
      timestamp: Date.now()
    };

    console.log('✅ Adding notification:', notification);
    console.log('📊 Current active notifications:', activeNotifications);

    setActiveNotifications(prev => {
      const updated = [...prev, notification];
      console.log('📊 Updated active notifications:', updated);
      return updated;
    });
  };

  const removeEpisodeNotification = (episodeId) => {
    setActiveNotifications(prev => prev.filter(n => n.id !== episodeId));
  };

  const value = {
    addEpisodeNotification,
    removeEpisodeNotification,
    activeNotifications
  };

  // Debug: Log when activeNotifications changes
  useEffect(() => {
    console.log('📊 Active notifications updated:', activeNotifications);
  }, [activeNotifications]);

  return (
    <EpisodeNotificationContext.Provider value={value}>
      {children}

      {/* Render active notifications */}
      <div className="fixed top-0 right-0 z-[100] pointer-events-none">
        <div className="flex flex-col gap-3 p-4 pointer-events-auto">
          {console.log('🔍 Rendering notifications, count:', activeNotifications.length)}
          {activeNotifications.map((notification, index) => {
            console.log('🔍 Rendering notification:', notification.id, 'at index:', index);
            return (
              <div
                key={notification.id}
                style={{
                  marginTop: index > 0 ? '8px' : '0'
                }}
              >
                <EpisodeProgressNotification
                  episodeId={notification.id}
                  onDismiss={() => removeEpisodeNotification(notification.id)}
                  onComplete={() => {
                    // Optionally trigger a refresh or notification
                    console.log('Episode completed:', notification.id);
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </EpisodeNotificationContext.Provider>
  );
};
